/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { LocalDate } from 'js-joda';
import {
  checkFormHasError,
  getFormHelperText,
  handleChangeFormFieldValue,
} from 'ui/forms/formHelpers';
import { useField, useFormikContext } from 'formik';
import DatePickerField, { DatePickerFieldProps } from 'ui/DatePickerField';

/**
 *@deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
function FormDatePickerField({
  helperText,
  PopoverProps,
  CalendarProps,
  onChange,
  onBlur,
  ...rest
}: DatePickerFieldProps) {
  const [field, meta] = useField(rest as any);
  const [clicked, setClicked] = React.useState(false);
  const formikContext = useFormikContext() as any;

  const handleChange = (date: LocalDate) => {
    handleChangeFormFieldValue(field, formikContext, date, onChange as any);
  };

  const handleBlur = (event: React.FocusEvent<any>) => {
    const shouldValidate = clicked ? meta.touched : true;
    formikContext.setFieldTouched(field.name, true, shouldValidate);
  };

  const handleClick = (event: React.MouseEvent<any>) => {
    setClicked(true);
  };

  const hasError = checkFormHasError(meta);

  const helperTextValue = getFormHelperText(hasError, meta, helperText);

  return (
    <DatePickerField
      error={hasError}
      helperText={helperTextValue as string}
      {...field}
      {...rest}
      onChange={handleChange}
      onClick={handleClick}
      onBlur={handleBlur}
      CalendarProps={{ ...CalendarProps }}
      PopoverProps={{ ...PopoverProps }}
    />
  );
}

export default FormDatePickerField;
